import api, { checkTokenErrorResponse } from '.';

export const accessTypes = [
    [0, 'Administrador'],
    [1.1, 'Administrativo-Financeiro-Contas'],
    [1.2, 'Administrativo-Financeiro-Contas-Bancárias'],
    [1.3, 'Administrativo-Financeiro-Cadastros'],
    [1.4, 'Administrativo-Financeiro-Estoque'],
    [2, 'Jurídico'],
    [3, 'Técnico'],
    [4, 'Sócio'],
    [5, 'Patrimônio'],
    [6, 'Eventos'],
]

export function verifyAdmFinAccess() {
    const accessInfo = localStorage.getItem('_accessInfos');
    if (!accessInfo)
        return false;
    
    const accessInfoTypes = JSON.parse(accessInfo).tipos;

    for(const access of accessInfoTypes) {
        if(access.tipo.includes("Administrativo-Financeiro"))
            return true;
    }
    return false;
}

export function getAdmFinAccess() {
    const accessInfo = localStorage.getItem('_accessInfos');
    if (!accessInfo)
        return [];
    
    const accessInfoTypes = JSON.parse(accessInfo).tipos;

    return accessInfoTypes.filter(type => type.tipo.includes("Administrativo-Financeiro") || type.tipo.includes("Administrador"))
}

export async function getAccessInfos(id) {
    return api.get(`acessos/${id}/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        })
};

export async function getAccessesInfos() {
    return api.get(`acessos/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        })
};

export async function deleteAccess(id) {
    return api.delete(`acessos/${id}/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        })
};

export async function patchAccess(id, nome, telefone, ddi, iso2_ddi, email, password = "",foto = null) {
    const formdata = new FormData();
    formdata.append('nome', nome);
    formdata.append('telefone', telefone);
    formdata.append('ddi', ddi);
    formdata.append('iso2_ddi', iso2_ddi);
    formdata.append('email', email);
    if (password !== "")
        formdata.append('password', password);

    if(foto !== null)
        formdata.append("foto", foto);
    return api.patch(`acessos/${id}/`, formdata)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        })
};

export async function postAccess(nome, telefone, ddi, iso2_ddi, email, password,foto = null) {
    const formdata = new FormData();
    formdata.append('nome', nome);
    formdata.append('telefone', telefone);
    formdata.append('ddi', ddi);
    formdata.append('iso2_ddi', iso2_ddi);
    formdata.append('email', email);
    formdata.append('password', password);

    if(foto !== null)
        formdata.append("foto", foto);
    return api.post(`acessos/`, formdata)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        })
};

export async function disableAccess(id) {
    return api.patch(`acessos/${id}/desativar_acesso/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function activateAccess(id) {
    return api.patch(`acessos/${id}/ativar_acesso/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function patchAccessPassword(id, password) {
    
    return api.patch(`acessos/${id}/`, {password})
    .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function giveAccess(id, tipos = []) {
    return api.post(`acessos/${id}/dar_acesso/`, {tipos})
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function takeAccess(id, tipos = []) {
    return api.post(`acessos/${id}/retirar_acesso/`, {tipos})
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}


const accessServices = {
    getAccessInfos,
    getAccessesInfos,
    deleteAccess,
    postAccess,
    patchAccess,
    activateAccess,
    disableAccess,
    patchAccessPassword,
    giveAccess,
    takeAccess,
    verifyAdmFinAccess,
    getAdmFinAccess,
    accessTypes,
}
export default accessServices;